//@ts-check

/**
 * @typedef {object} AuthUser
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {'admin'|'employee'} role
 * @property {{ record: boolean, view: boolean, download: boolean, share: boolean }} permissions
 * @property {boolean} isActive
 */

/**
 * @param {AuthUser|null|undefined} user
 * @returns {boolean}
 */
export function isAdmin(user) {
  return user?.role === 'admin';
}

/**
 * @param {AuthUser|null|undefined} user
 * @param {'record'|'view'|'download'|'share'} permission
 * @returns {boolean}
 */
export function hasPermission(user, permission) {
  if (!user) return false;
  if (isAdmin(user)) return true;
  return Boolean(user.permissions?.[permission]);
}

/**
 * Permission chips for the users table.
 * @param {AuthUser} user
 * @returns {string[]}
 */
export function permissionLabels(user) {
  if (isAdmin(user)) return ['Full Access'];
  /** @type {Array<'record'|'view'|'download'|'share'>} */
  const keys = ['record', 'view', 'download', 'share'];
  return keys.filter((k) => user.permissions?.[k]).map((k) => k[0].toUpperCase() + k.slice(1));
}
